import { render } from "./SystemThemeUploadView.vue?vue&type=template&id=159d501a&scoped=true&ts=true"
import script from "./SystemThemeUploadView.vue?vue&type=script&lang=ts"
export * from "./SystemThemeUploadView.vue?vue&type=script&lang=ts"

import "./SystemThemeUploadView.vue?vue&type=style&index=0&id=159d501a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159d501a"]])

export default __exports__